const RIDDLED_IN_DEMO_ROUNDS = Object.freeze([
  {
    id: 'compass',
    word: 'COMPASS',
    riddle:
      "I'm loyal to something you'll never quite see,\n" +
      "I drift when I'm near what the world hides in me.\n" +
      'I argue with metal, I settle with time,\n' +
      'And make circles behave like a silent rhyme.',
  },
  {
    id: 'mirror',
    word: 'MIRROR',
    riddle:
      "I give you a twin that can't learn how to speak,\n" +
      "It moves when you move, but it's never unique.\n" +
      "It lives on a surface that isn't a skin,\n" +
      "And breaks into truths you can't put back in.",
  },
  {
    id: 'volcano',
    word: 'VOLCANO',
    riddle:
      "I'm a closed mouth holding a brighter opinion,\n" +
      'A stitched-up horizon with heat as dominion.\n' +
      "I sleep like a hill with a temper inside,\n" +
      'Then rewrite the air when I finally decide.',
  },
  {
    id: 'tornado',
    word: 'TORNADO',
    riddle:
      "I'm a thought that turns vertical, born from a mood,\n" +
      "A thin little verdict that's never been sued.\n" +
      "I don't have a body, just pressure and spin,\n" +
      'Yet I pull up a town like a sleeve from the wind.',
  },
  {
    id: 'aurora',
    word: 'AURORA',
    riddle:
      "I'm light that got lost and returned wearing silk,\n" +
      'A cold kind of fire poured slow like milk.\n' +
      'I bloom where the map forgets color exists,\n' +
      'And vanish the moment you tighten your fists.',
  },
  {
    id: 'whiskey',
    word: 'WHISKEY',
    riddle:
      "I'm grain that forgot it was meant to be bread,\n" +
      "I learn in the dark from the wood where I'm fed.\n" +
      "I arrive as a story that stings when it's told,\n" +
      'Then leave you with warmth and a careful kind of bold.',
  },
  {
    id: 'oyster',
    word: 'OYSTER',
    riddle:
      "I'm a mouth with no voice and a secret to keep,\n" +
      'A patient small lock in a city of deep.\n' +
      "I don't chase the prize - I manufacture it slow,\n" +
      "And dare you to love what you'd rather not know.",
  },
  {
    id: 'pyramid',
    word: 'PYRAMID',
    riddle:
      "I'm arithmetic turned into weight and into time,\n" +
      'A staircase for nothing, a stubborn old climb.\n' +
      "No door that you trust, no window that's kind,\n" +
      'Just angles that outlive the hands that designed.',
  },
  {
    id: 'caviar',
    word: 'CAVIAR',
    riddle:
      "I'm a fortune in dots that won't wait on a plate,\n" +
      'A briny soft Morse code that whispers "too late."\n' +
      "I'm born where the river forgets it's not sea,\n" +
      "Then sold as a hunger that's mostly a key.",
  },
  {
    id: 'bandit',
    word: 'BANDIT',
    riddle:
      "I'm a shadow with manners that vanish at dawn,\n" +
      'A tax with no paperwork quietly drawn.\n' +
      "I don't need a kingdom - just timing and nerve,\n" +
      'And I leave you still standing, but slightly unserved.',
  },
]);

const roundById = new Map(
  RIDDLED_IN_DEMO_ROUNDS.map((round) => [round.id, round]),
);

export const pickRandomRiddledInDemoRound = (lastRoundId = '') => {
  const normalizedLastRoundId = String(lastRoundId || '').trim();
  if (RIDDLED_IN_DEMO_ROUNDS.length <= 1) {
    return RIDDLED_IN_DEMO_ROUNDS[0];
  }

  const eligibleRounds = RIDDLED_IN_DEMO_ROUNDS.filter(
    (round) => round.id !== normalizedLastRoundId,
  );
  const pool = eligibleRounds.length > 0 ? eligibleRounds : RIDDLED_IN_DEMO_ROUNDS;
  const randomIndex = Math.floor(Math.random() * pool.length);
  return pool[randomIndex];
};

export const getRiddledInDemoRoundById = (idRaw = '') => {
  const id = String(idRaw || '').trim();
  if (!id) return null;
  return roundById.get(id) || null;
};
